import { Box, ColorOptions, IconButton, Loader, ModBox, Spacer, Text } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { DefaultDropDown } from '../../../comps/DropdownNew/DefaultDropDown'
import {
  TitleSubtitleLayout,
  TitleSubtitleLayoutColorTheme,
  TitleSubtitleLayoutTypes
} from '../../../comps/TitleSubtitleLayoutNew'
import { Colors, useWindowDimensions } from '../../../util/util'
import { styles } from './styles'

interface HeaderProps {
  closeDetailsView?: () => void
  hide?: boolean
  onVerifySave?: () => void
  onCancel?: () => void
  isValid?: boolean
  isLoading?: boolean
  setEditMode?: (isEdit: boolean) => void
}

const MobileView = (viewPortWidth: number, closeDetailsView: () => void) => {
  const themes = styles(viewPortWidth)

  return (
    <Box {...themes.backgroundColor}>
      <Box {...themes.headerContainer}>
        <Box {...themes.ernContainer}>
          <TitleSubtitleLayout
            type={TitleSubtitleLayoutTypes.BOLD_TITLE}
            placeHolder={'Beneficiary Details'}
            color={TitleSubtitleLayoutColorTheme.BOLD_TITLE}
            title={''}
          />
          <Box {...themes.iconStyle}>
            <IconButton
              color={Colors.GREY_C as ColorOptions}
              size={20}
              id={'CLOSE'}
              testID="btn-closeDetailsView"
              onPress={closeDetailsView}
            />
          </Box>
        </Box>
        <Spacer size={16} />
      </Box>
      <Box h={2} width="100%" backgroundColor={'SEPERATOR'} />
    </Box>
  )
}

const Header: FC<HeaderProps> = ({
  closeDetailsView = () => { },
  hide = false,
  onVerifySave,
  onCancel,
  isValid,
  isLoading,
  setEditMode,
}: HeaderProps) => {
  const [showMoreOptions, setMoreOptions] = useState(false)
  const [isEditSelected, setEditSelected] = useState(false)

  const onMoreOptionsPress = () => {
    setMoreOptions((prev) => !prev)
  }
  const onOptionSelected = (valueSelected: any) => {
    console.log('Header onOptionSelected : ', valueSelected)
    setMoreOptions(false)
    setEditSelected(valueSelected?.value === 'Edit Beneficiary')
    setEditMode(valueSelected?.value === 'Edit Beneficiary')
  }

  const onHandleCancel = () => {
    setEditMode(false)
    onCancel && onCancel()
    setEditSelected(false)
  }

  const viewPortWidth = useWindowDimensions()

  const themes = styles(viewPortWidth)

  if (viewPortWidth < 700) {
    return MobileView(viewPortWidth, closeDetailsView)
  }

  if (hide) {
    return null
  }
  return (
    <Box {...themes.backgroundColor}>
      <Box {...themes.headerContainer}>
        <Box justifyContent={'center'}>
          <Box {...themes.ernContainer}>
            <Text fontFamily="jiotype-bold" fontSize={18} color={'BLACK'}>
              {isEditSelected ? 'Edit Beneficiary' : 'Beneficiary Details'}
            </Text>
          </Box>
        </Box>
        <Box {...themes.exportContainer}>
          <ModBox show={isEditSelected}>
            <Box alignSelf="flex-end" flexDirection="row" justify="center">
              <ModBox
                w={112}
                h={40}
                testID="back"
                onPress={onHandleCancel}
                justifyContent="center"
                underlayColor="TRANSPARENT"
                borderWidth={1}
                borderRadius={8}
                borderColor="BLUE"
                pv={5}
                ph={10}
                alignItems={'center'}>
                <Text fontFamily="jiotype-medium" fontSize={14} color="BLUE">
                  {'Cancel'}
                </Text>
              </ModBox>
              <Spacer direction="horizontal" size={16} />
              <Box
                w={118}
                testID="verifyNSave"
                onPress={onVerifySave}
                disabled={isLoading}
                bg="BLUE"
                underlayColor="TRANSPARENT"
                opacity={1}
                pv={5}
                ph={18}
                borderRadius={6}
                justifyContent="center">
                {isLoading ? (
                  <Loader color="WHITE" />
                ) : (
                  <Text type={'body2'} fontWeight={'600'} fontSize={12} color="WHITE">
                    {'Verify & Save'}
                  </Text>
                )}
              </Box>
            </Box>
          </ModBox>
          <ModBox show={!isEditSelected} {...themes.iconStyle}>
            <IconButton testID={'moreOptions'} size={20} color={'BLACK'} id={'OPTIONS'} onPress={onMoreOptionsPress} />
            <ModBox
              show={showMoreOptions}
              position={'absolute'}
              top={20}
              right={20}
              backgroundColor={'WHITE'}
              borderRadius={4}
              borderWidth={1}
              borderColor={'GRAY_BORDER'}
              shadowRadius={4}
              shadowType={'shadowPrimary'}
              shadowColor={'GRAY_SHADOW'}>
              <DefaultDropDown
                data={[
                  { id: '1', value: 'Edit Beneficiary' },
                  // { id: '2', value: 'Delete' },
                ]}
                onDropdownItemPress={onOptionSelected}
                isExportType={false}
                height={82}
                width={150}
              />
            </ModBox>
          </ModBox>
          <Spacer size={16} direction="horizontal" />
          <Box {...themes.iconStyle}>
            <IconButton
              testID={'closeDetails'}
              size={20}
              color={Colors.GREY_C as ColorOptions}
              id={'CLOSE'}
              onPress={closeDetailsView}
            />
          </Box>
        </Box>
      </Box>
      <Box h={2} width="100%" backgroundColor={'SEPERATOR'} zIndex={-100} />
    </Box>
  )
}

export default Header
